import { useHistory } from 'react-router-dom';

import { IS_ADMIN } from '../config';

// Admin renders the same tables but has no /transactions/:transactionId route,
// so it gets no handler and DataTable falls back to its no-op default.
const useOpenTransactionDetails = () => {
  const history = useHistory();

  if (IS_ADMIN) return undefined;

  return ({ id } = {}) => {
    if (!id) return;
    history.push(`/transactions/${encodeURIComponent(id)}`);
  };
};

export { useOpenTransactionDetails };
